// extracted by mini-css-extract-plugin
export default {"main":"styles_main__BwfA0","block":"styles_block__XaKgG"};